import { render, staticRenderFns } from "./TaskDropdownActions.vue?vue&type=template&id=0bc47d71"
import script from "./TaskDropdownActions.vue?vue&type=script&lang=js"
export * from "./TaskDropdownActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports